import type { LucideIcon } from "lucide-react";
import { Input } from "./ui/input";

export function SectionTitle({ icon: Icon, title }: { icon: LucideIcon; title: string }) {
  return (
    <div className="mb-4 flex items-center gap-2 px-1">
      <Icon className="size-4 text-primary" />
      <h3 className="text-sm font-bold uppercase tracking-wider text-foreground/70">{title}</h3>
    </div>
  );
}

export function ColorControl({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="color-control">
      <span>{label}</span>
      <div className="color-row">
        <Input
          type="color"
          className="color-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <span className="hex-value">{value}</span>
      </div>
    </label>
  );
}
